import React, {Component} from "react";
import {connect} from "react-redux";
import FJResourcesTransitionList from "../view/FJResourcesTransitionList";
import FJLocalStore from "../../../store/FJLocalStore";
import styles from '../view/FJResourcesTransitionList.module.less';
import {FJMediaAction} from "../../../redux/action/FJRoot.action";
import $ from "jquery";
import FJPanelAnimation from "../../../common/component/FJPanelAnimation/FJPanelAnimation";
import key from "keymaster";
import {FJTransitionStore} from 'fj-graph'
import FJConfig from "../../../config/FJConfig";

class FJResourcesTransitionContainer extends Component {

  constructor(props) {
    super(props);
    this._transitions = FJTransitionStore.getAllTransitionData();
    this.resourceViewInfo = {
      width: 140,
      height: 84,
      space: 10,
      marginBottom: 10
    };
    this.classes = {
      pageHeaderClasses: {
        listBox: styles.header_list_box,
        seeAllBox: '',
        titleBox: styles.text_animation_box,
        moreBox: '',
      },
      pageHeaderBackClasses: {
        headerBox: '',
        backBox: '',
        titleBox: '',
        backTextBox: ''
      },
      itemClasses: {
        resourceItem: styles.item,
        resourceItemActive: styles.active,
        inner: styles.inner_box,
        addBtnBox: '',
        deleteBtnBox: '',
        addBtn: '',
        name: styles.transition_name,
        link: '',
        refresh: '',
        reloadIcon: ''
      }
    }
    this.config = {};
  }

  /**
   * @description 拖动资源库文件
   * @param e
   * @param data
   * @param callback
   * @private
   */
  _onMediaDrag = (e, data, callback) => {
    let {eventType} = data;

    let point = {
      x: e.clientX,
      y: e.clientY,
    };

    let isInAddArea = point.y >= document.body.clientHeight - $(document.getElementById('timeline-container')).height();
    this._dragInfo = data;
    this._dragCallback = callback;

    switch (eventType) {
      case 'start':
        key.setScope('');
        break;
      case 'change':
        if (isInAddArea) {
          if (this._isDragToTimeline) {
            this._renderDragToTimeline('change', point);
            return
          }
          this._renderDragToTimeline('start', point);
          this._isDragToTimeline = true;
        } else {
          if (this._isDragToTimeline) {
            callback('delete');
            // 删除添加到时间轴的资源
            this.props.deleteDragToTimeline && this.props.deleteDragToTimeline();
          }
          callback('continue');
          this._removeContentCloneNode();
          this._isDragToTimeline = false;
        }
        break;
      case 'end':
				key.setScope('default');
        if (isInAddArea) {
          this._renderDragToTimeline('end', point);
          this._removeContentCloneNode();
        }
        this._isDragToTimeline = false;
        break;
    }
  };

  /**
   * @description 渲染拖动元素到时间轴区域的dom样式
   * @param type
   * @param point
   * @param offsetPoint
   * @private
   */
  _renderDragToTimeline = (type, point) => {

    if (!type || !point) {
      return;
    }

    // let unitConversion = FJTimelineStore.getUnitConversion();
    // let duration = FJConfig.fixedDuration;
    let selfRectHeight = 88;

    let selfRect = {
      width: 140,
      height: selfRectHeight,
    };

    if (type === 'start') {
      this._dragCallback('delete');
      this._cloneNode = this._cloneNode || document.createElement('div');
      this._cloneNode.appendChild(this._getDragNodeInTimeLine(selfRect));
      document.body.appendChild(this._cloneNode);
    }

    $(this._cloneNode).css({
      visibility: 'visible',
      position: 'fixed',
      bottom: 'inherit',
      left: point.x,
      top: point.y - selfRect.height / 2,
      width: selfRect.width,
      zIndex: FJConfig.mediaDragZindex,
      cursor: 'move',
			opacity: .8,
    });

    let info = {
      dragMode: 2,
      eventType: type,
      cursorPoint: point,
      selfRect: {
        left: point.x,
        top: point.y - selfRect.height / 2,
        ...selfRect
      }
    };
    this.props.dragToTimeline(this._dragInfo.id, {eventType: type, ...info});
  };

  /**
   * @description 得到拖动background到时间轴的样式
   * @param selfRect
   * @returns {HTMLDivElement}
   * @private
   */
  _getDragNodeInTimeLine = (selfRect) => {
    let node = document.createElement('div');

    let url = this._dragInfo.getUrl;
    let backgroundImage = 'url(' + url + ')';

    $(node).addClass(styles.active);

    $(node).css({
      width: selfRect.width,
      height: selfRect.height,
      backgroundColor: 'auto',
      backgroundPosition: 'auto',
      backgroundImage: backgroundImage,
      borderColor: '#FF822C',
      borderRadius: '4px',
    });
    return node;
  };

  /**
   * @description 删除添加的随着鼠标拖动的div
   */
  _removeContentCloneNode = () => {
    if (this._cloneNode && this._cloneNode.parentNode) {
      this._cloneNode.parentNode.removeChild(this._cloneNode);
      this._cloneNode = null;
    }
  };

  _render = () => {
    let {isShow, onHandleClick, chooseMediaIdList} = this.props
    return (
      <FJResourcesTransitionList isShow={isShow}
                                 allResources={this._transitions}
                                 resourceViewInfo={this.resourceViewInfo}
                                 seeAllText={FJLocalStore._('see-all')}
                                 config={this.config}
                                 classes={this.classes}
                                 onHandleClick={onHandleClick}
                                 onMediaDrag={this._onMediaDrag}
                                 chooseMediaIdList={chooseMediaIdList}
      />
    );
  };

  render() {
    let {isShow, direction} = this.props
    return (
      <FJPanelAnimation active={isShow} direction={direction} render={this._render} />
    )
  }
}

const mapStateToProps = function (state) {
  return {
    chooseMediaIdList: state.media.chooseMediaIdList,
    direction: state.resource.direction,
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    onHandleClick: function (id, type, rate) {
      dispatch(FJMediaAction.selectMediaAction(id, type, rate));
    },
    dragToTimeline: function (id, data) {
      dispatch(FJMediaAction.dragTransitionToTimelineAction(id, data));
    },
    deleteDragToTimeline: function () {
      dispatch(FJMediaAction.abortDragTransitionAction());
    },
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(FJResourcesTransitionContainer);